import ApiService from '@/services/api.service'

const PassportSeriaService = {
    getList: async function (data) {
        return ApiService.post(`/passport-serial-list`, data)
    }
}

export default PassportSeriaService;
